import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { Store } from "@ngxs/store";
import { map } from "rxjs/operators";
import { EventModel } from "src/app/shared/interfaces/administrator";
import {
  GET_ALL_EVENT_LIST,
  GET_EVENT_CHANNEL_LIST,
  GET_EVENT_MANAGEMENT,
  GET_EVENT_SUMMARY,
  SAVE_EVENT,
  SET_EVENT_ALERT_ARCHIVED,
  UPDATE_EVENT,
  UPDATE_EVENT_MANAGEMENT,
} from "src/app/store/event-management/event.action";

import { EventService } from "./event.service";

@State<EventModel>({
  name: "EventState",
  defaults: {
    eventHistory: null,
    createEvent: null,
    eventList: null,
    viewAllEvent: null,
    archivedEvent: null,
    eventSummary: null,
    updateEvent: null,
    eventChannelList: null,
  },
})
@Injectable()
export class EventState {
  constructor(
    private readonly eventService: EventService,
    private readonly store: Store,
  ) {}
  @Selector()
  public static createEvent(state: EventModel) {
    return state.createEvent;
  }
  @Selector()
  public static eventResponseList(state: EventModel) {
    return state.eventList;
  }
  @Selector()
  public static eventHistoryList(state: EventModel) {
    return state.eventList ? state.eventList : [];
  }

  @Selector()
  public static eventChannelResponseList(state: EventModel) {
    return state.eventChannelList;
  }
  @Selector()
  public static viewAllEvent(state: EventModel) {
    return state.viewAllEvent ? state.viewAllEvent : [];
  }

  @Selector()
  public static eventAlertArchived(state: EventModel) {
    return state.archivedEvent;
  }

  @Selector()
  public static eventSummary(state: EventModel) {
    return state.eventSummary ? state.eventSummary : [];
  }

  @Action(SAVE_EVENT)
  public saveEvent(
    { patchState }: StateContext<EventModel>,
    { payload }: SAVE_EVENT,
  ) {
    return this.eventService.saveEvent(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            createEvent: {
              iscreateEventSuccess: res.error ? false : true,
              eventResponse: res,
              createEventErrormsg: res.error ? res.error : null,
            },
          });
        }
      }),
    );
  }

  @Action(GET_EVENT_MANAGEMENT)
  public getEventList(
    { patchState }: StateContext<EventModel>,
    { payload }: GET_EVENT_MANAGEMENT,
  ) {
    return this.eventService.getEventList(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            eventList: res,
          });
        }
      }),
    );
  }

  @Action(UPDATE_EVENT_MANAGEMENT)
  public updateEvent(
    { patchState }: StateContext<EventModel>,
    { payload }: SAVE_EVENT,
  ) {
    return this.eventService.saveEvent(payload).pipe(
      map((res) => {
        if (res.saveSuccess) {
          patchState({
            createEvent: {
              iscreateEventSuccess: true,
              eventResponse: res,
              createEventErrormsg: null,
            },
          });
        } else {
          patchState({
            createEvent: {
              iscreateEventSuccess: false,
              createEventErrormsg: res.error,
              eventResponse: null,
            },
          });
        }
      }),
    );
  }

  @Action(GET_ALL_EVENT_LIST)
  public getAllEventList(
    { patchState }: StateContext<EventModel>,
    { payload }: GET_ALL_EVENT_LIST,
  ) {
    return this.eventService.getAllEventList(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            viewAllEvent: res,
          });
        }
      }),
    );
  }

  @Action(SET_EVENT_ALERT_ARCHIVED)
  public setLoginAlertArchived(
    { patchState }: StateContext<EventModel>,
    { payload }: GET_ALL_EVENT_LIST,
  ) {
    return this.eventService.setEventAlertArchived(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            archivedEvent: {
              isarchivedEventSuccess: true,
              eventResponse: res,
              archivedEventErrormsg: null,
            },
          });
        } else {
          patchState({
            archivedEvent: {
              isarchivedEventSuccess: false,
              archivedEventErrormsg: res.error,
              eventResponse: null,
            },
          });
        }
      }),
    );
  }

  @Action(GET_EVENT_SUMMARY)
  public getEventSummary(
    { patchState }: StateContext<EventModel>,
    { payload }: GET_EVENT_SUMMARY,
  ) {
    return this.eventService.getAllEventList(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            eventSummary: res,
          });
        }
      }),
    );
  }

  @Action(UPDATE_EVENT)
  public updateEventAdmin(
    { patchState }: StateContext<EventModel>,
    { payload }: UPDATE_EVENT,
  ) {
    return this.eventService.updateEvent(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            updateEvent: {
              isUpdateEventSuccess: true,
              updateEventErrormsg: null,
              eventResponse: res,
            },
          });
        } else {
          patchState({
            updateEvent: {
              isUpdateEventSuccess: false,
              updateEventErrormsg: res.error,
              eventResponse: null,
            },
          });
        }
      }),
    );
  }

  @Action(GET_EVENT_CHANNEL_LIST)
  public getEventChannelList({ patchState }: StateContext<EventModel>) {
    return this.eventService.getEventChannelList().pipe(
      map((res) => {
        if (res) {
          patchState({
            eventChannelList: res,
          });
        }
      }),
    );
  }
}
